import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge20 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権購入の流れ' fontWeight={700} />
                <Heading3 title='購入価格の相場を調べる' />
                <p>
                    ご希望のゴルフ会員権がはたしていくらで購入できるのか、まずは現在の価格相場を知る必要があります。一般的には、弊社のようなゴルフ会員権業者に電話でお問合せいただく、もしくは会員権業者のホームページを検索するといった方法があります。どちらの方法を選んでいただいても問題ありませんが、現在の売り手の希望売却価格、買い手の希望購入価格、またそれぞれの件数を知ることができます。売り手と買い手の双方の希望価格が判れば、ご希望の会員権がどのくらいの価格で買えるか、大体のイメージをつかむことができるでしょう。
                </p>

                <Heading3 title='購入先を探す' />
                <p>
                    購入先を探す方法としては、弊社のようなゴルフ会員権業者に依頼することが一般的です。その際、上記のような方法で現在の価格相場をある程度把握した上で、希望購入金額も含めて購入のお問合せをしていただくのが良いでしょう。お問合せの方法は電話でもゴルフ会員権業者のホームページからでもどちらでも可能です。その際に費用は発生しませんし、お問合せ後の変更や取り消しも自由ですので、気軽にお問合せしていただければと思います。
                </p>

                <Heading3 title='購入から名義書換の手続きを行う' />
                <p>
                    購入先が見つかり、金額の合意ができたら、会員権購入の準備をすることになります。
                    <br />
                    まず、購入代金をご用意いただき、会員権が入手できるタイミングに合わせて代金の決済を行います。通常、代金の決済は会員権業者に対して行い、それと同時に会員権一式を受け取ります。
                    <br />
                    会員権一式には、ゴルフ会員権証書（証券）の他に、入会に必要な書類も含まれています。そこにご記入いただいたら、写真などの必要書類を添えてクラブに提出することになります。提出は会員権業者が代行することも可能ですので、購入する前に確認しておくと良いでしょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権購入におけるトラブル回避のポイント' fontWeight={700} />

                <Heading3 title='契約内容と受け渡し' />
                <p>
                    会員権業者から購入する場合は、事前に会員権本体の価格や諸費用を確認しておくことが大切です。可能であれば、メール等のやり取りで金額の記載を含めて交渉の履歴を残しておくと良いでしょう。
                    <br />
                    会員権一式の受け渡し時には、証券を確認してから代金の決済を行うことをお勧めします。
                </p>

                <Heading3 title='購入先の信頼性やリスク回避の方法' />
                <p>
                    実績のある大手の会員権業者を選ぶことがまずは重要です。何らかの事情で大手以外の会員権業者を選ばなければならないときは、ゴルフ会員権取引業協同組合に加盟しているかを確認してください。どの会員権業者を選ぶにしても、前項に記載の通り、会員権証券を確認してから代金の決済を行うことがリスクの回避につながります。
                    <br />
                    また、入会条件の確認も大切です。会員権を購入したのにも関わらず、入会できないというトラブルだけは避けるべきなので、会員権を購入する前に必ず確認を実施しましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権購入の費用や税金について' fontWeight={700} />

                <Heading3 title='購入にかかる手数料や費用' />
                <p>
                    会員権本体の価格、会員権業者への手数料、年会費の負担分、場合によっては推薦者（クラブの会員）への謝礼金などが必要となります。それぞれの具体的な内容については
                    <a href='/knowledge/13'>こちら</a>
                    をご確認ください。また、名義書換が終了したら、クラブから名義書換料の請求があります。
                    <br />
                    税金面では、会員権業者との交渉過程で、会員権本体価格が消費税込みか否かを確認しましょう。
                    <br />
                    <br />
                    会員権業者への手数料は会員権本体価格の2％です。また275万円（税込）以下のゴルフ会員権は定額の5.5万円（税込）になります。これはゴルフ会員権を売却するときも一緒です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権購入の成功事例や失敗事例' fontWeight={700} />

                <Heading3 title='購入成功のポイントやコツ' />
                <p>
                    「ゴルフ会員権購入の流れ」でも説明しましたが、まずは購入しようとするゴルフ会員権の相場を把握することがポイントです。次に購入の登録をした後に、ゴルフ会員権業者から何かしらのオファーがあると思います。オファーにはなるべく早く返事をすることが大切です。決断が遅くなると、その話が流れてしまうリスクがあるからです。その後はなかなか売り手が現れず、結果としてタイミングを逃してしまうこともあります。やはり相場の把握と決断の速さが成功のカギといえます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                ゴルフ会員権の購入時のポイントを順番に挙げてみます。
                <p>
                    ①『購入するゴルフ会員権の相場を把握する』
                    <br />
                    そのためにはゴルフ会員権業者に直接聞くかゴルフ会員権業者のホームページを検索すると良いでしょう。
                </p>
                <p>
                    ②『ゴルフ会員権業者に売買を依頼する』
                    <br />
                    できれば希望価格を告げて購入の登録をすることが望ましいと思います。
                </p>
                <p>
                    ③『交渉過程の履歴を残す』
                    <br />
                    トラブルを回避するため、会員権業者との交渉過程で、成約した金額の記載を含めやりとりの履歴を残しておきましょう。
                </p>
                <p>
                    ④『受け渡しは同時に』
                    <br />
                    ゴルフ会員権の代金は証券等の必要書類の受け渡しと同時に行うことが基本です。
                </p>
                <p>
                    ご購入の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge20;
